import React, { useState, useEffect } from 'react';

const CreateVehicleModal = ({ isOpen, onClose, onSave, vehicle }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    number: '',
    images: [],
  });

  useEffect(() => {
    if (vehicle) {
      setFormData({
        name: vehicle.name,
        description: vehicle.description,
        number: vehicle.number,
        images: [],
      });
    } else {
      setFormData({
        name: '',
        description: '',
        number: '',
        images: [],
      });
    }
  }, [vehicle]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, images: [...e.target.files] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-2xl w-full max-h-[90vh] flex flex-col">
        <h2 className="text-2xl font-bold text-[#364A9A] mb-6 font-poppins">{vehicle ? 'Edit' : 'Create'} Vehicle</h2>
        <form onSubmit={handleSubmit} className="space-y-4 overflow-y-auto">
          <div>
            <label htmlFor="name" className="block text-gray-700 font-bold mb-2">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#364A9A]"
              required
            />
          </div>
          <div>
            <label htmlFor="description" className="block text-gray-700 font-bold mb-2">Description</label>
            <textarea
              id="description"
              name="description"
              rows="5"
              value={formData.description}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#364A9A]"
            
            ></textarea>
          </div>
          <div>
            <label htmlFor="number" className="block text-gray-700 font-bold mb-2">Number</label>
            <input
              type="number"
              id="number"
              name="number"
              value={formData.number}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#364A9A]"
              required
            />
          </div>
          <div>
            <label htmlFor="images" className="block text-gray-700 font-bold mb-2">Images</label>
            <input
              type="file"
              id="images"
              name="images"
              onChange={handleFileChange}
              multiple
              className="w-full"
            />
          </div>
          <div className="text-right mt-6">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-500 text-white font-bold py-2 px-4 rounded-lg mr-2"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-green-500 text-white font-bold py-2 px-4 rounded-lg"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateVehicleModal;